import { render, staticRenderFns } from "./MemberImportDialog.vue?vue&type=template&id=2b36e6dc"
import script from "./MemberImportDialog.vue?vue&type=script&lang=js"
export * from "./MemberImportDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports